<template>
  <div class="container">
    <van-nav-bar title="施工管理" left-text="" right-text="新增" left-arrow @click-left="onClickLeft"
      @click-right="changePage('')">
    </van-nav-bar>
    <van-list v-model="loading" :finished="finished" :finished-text="projectList.length > 0 ? '没有更多了' : '暂无数据'"
      @load="onLoad">
      <div class="list-box">
        <div class="list clearfix" @click="changePage(item)" :key="index" v-for="(item, index) in projectList">
          <div class="fl_left">
            <div class="mg10">项目：{{ item.community && item.community.name }}</div>
            <div class="">时间：{{ item.createTime }}</div>
          </div>
          <div class="fl_right">
            <div class="mg10">
              <span class="" v-if="item.status == 0">{{ statusList[item.status].name }}</span>
              <span class="col_g" v-if="item.status == 1">{{ statusList[item.status].name }}</span>
              <span class="col_r" v-if="item.status == 2">{{ statusList[item.status].name }}</span>
              <img src="../../assets/img/sel_right.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </van-list>

  </div>
</template>
  
<script>
import axios from '@/axios.js';
import { NavBar, Icon, Image, Toast, Loading, Picker, Field, Popup, List, } from 'vant';
export default {
  data() {
    return {
      allCount: 0,
      pageIndex: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      projectList: [],

      status: undefined,

      statusList: [
        { name: '待审核', value: 0 },
        { name: '已通过', value: 1 },
        { name: '未通过', value: 2 },
      ],
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List
  },
  methods: {
    changePage(item) {
      if (!item) {
        this.$router.push({ path: "createProject.html" })
      } else {
        this.$router.push({ path: "constructionDeviceList.html", query: { id: item.id } })
      }
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.pageIndex++;
        this.getMoreList();
      }, 500)
    },
    getProjectList() {
      this.loading = true;
      axios.post("/constructioncommunity/pagelist", {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        filter: {
          keyword: ""
        }
      }).then((res) => {
        // 加载状态结束
        this.loading = false;
        this.projectList = res.data.list;
        this.allCount = res.data.total;
        this.statistics = res.data.statistics;
      })
    },
    getMoreList() {
      axios.post("/constructioncommunity/pagelist", {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        filter: {
          keyword: ""
        }
      }).then((res) => {
        this.projectList = this.projectList.concat(res.data.list);
        this.allCount = res.data.total;
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.pageIndex * this.pageSize >= this.allCount) {
          this.finished = true;
        }
      })
    },
    onClickLeft() {
      this.$router.replace({ path: "home.html" });
    },
    onClickRight() {
    },
  },
  computed: {
  },
  created() {
    this.getProjectList();
  },
  mounted() { },
  destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
  width: 100%;
  height: 100%;
  background: #F0F4F7
}

.container {
  width: 100%;
  height: 100%;
  letter-spacing: 0px;
  background: #F0F4F7;
}

.list-box {
  width: 100%;
  color: #373737;

  .list {
    font-size: 14px;
    width: 100%;
    background: #fff;
    margin: 12px 0;
    padding: 12px;

    .fl_right {
      text-align: right;
      margin-top: 15px;

      img {
        width: 6px;
        margin-left: 8px;
        margin-bottom: 2px;
        vertical-align: middle;
      }
    }
  }

  .mg10 {
    margin-bottom: 10px;
  }

  .bold {
    font-weight: bold;
  }
}

.menu {
  width: 100%;
  height: 54px;
  line-height: 54px;
  text-align: center;
  background: #fff;

  .menuitem {
    width: 50%;
    display: inline-block;

    .icon {
      width: 10px;
      height: 6px;
      vertical-align: middle;
    }
  }
}
</style>
  